import {
    HttpClient,
    HttpParams
} from '@angular/common/http';
import {
    Injectable
} from '@angular/core';

import {AlertController} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';

import { DatePipe } from '@angular/common';
import { formatDate } from '@angular/common';

import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';
import { Subject } from 'rxjs';
import { Platform } from '@ionic/angular';

import IsoToLatLong from 'country-iso-to-coordinates';

import * as moment from 'moment';

import {
    MAP_MARKER_ICON,
    HEART_COLORS,
    MAP_SCOPE,
    MAP_PROVIDERS
} from './NeurConstants';


/*
import {
    PLACE_TYPES
} from './NeurPlaces';
*/

import {
    PLACE_CATEGORIES
} from './PlaceCategories';


import {
    NativeGeocoder,
    NativeGeocoderOptions,
    NativeGeocoderResult
} from '@ionic-native/native-geocoder/ngx';


import * as L from "leaflet";

import "leaflet";
import "proj4";
import "proj4leaflet";
import "leaflet-edgebuffer"

import * as CountryCoder from 'country-coder';

/*
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/

/* CRS for Baidu Map */
if (L.Proj) {

    L.CRS.Baidu = new L.Proj.CRS(
        'EPSG:900913', '+proj=merc +a=6378206 +b=6356584.314245179 +lat_ts=0.0 +lon_0=0.0 +x_0=0 +y_0=0 +k=1.0 +units=m +nadgrids=@null +wktext  +no_defs', {
            resolutions: function() {
                var level = 19;
                var res = [];
                res[0] = Math.pow(2, 18);
                for (var i = 1; i < level; i++) {
                    res[i] = Math.pow(2, (18 - i))
                }
                return res;
            }(),
            origin: [0, 0],
            bounds: L.bounds([-20037508.342789244, -20037508.342789244], [20037508.342789244, 20037508.342789233]),
        });
}


L.TileLayer.BaiduLayer = L.TileLayer.extend({

    getTileUrl: function(coords) {

        var data = {
            s: this._getSubdomain(coords),
            x: coords.x,
            y: coords.y,
            z: this._getZoomForUrl(),
        };

        if (this._map && !this._map.options.crs.infinite) {
            var invertedY = (this._globalTileRange.max.y + this._globalTileRange.min.y) - coords.y;
            if (this.options.tms) {
                data['y'] = invertedY;
            }
        }
        return L.Util.template(this._url, L.Util.extend(data, this.options));
    },

});

L.tileLayer.baiduLayer = function(type, options) {
    return new L.TileLayer.BaiduLayer(type, options);
};

/* END OF CRS FOR Baidu Map */

@Injectable()
class NeurService {

/* TBD */
    public _mapFlyToDestination = true;
    private map_provider: number = MAP_PROVIDERS.LEAFLET;
    
    public setMapProvider(provider: number) {
        this.map_provider = provider;
    }

    public getMapProvider() {
        return this.map_provider;
    }

/**/
    public locale;
    public monthAbbreviations;
    public weekdaysAbbreviations;

    public _initialDataLoaded = false;
    public _locationInitialized = false;
    public _placesInitialized = false;
    public _initialized = false;
    
    public _locationBasedOnGeo = false;
    
    public country_code;
    public ip_country_code;

    public current_location;
    public current_place;
    
    public metrics_setting; 
    
    public _phoneInputEnabled:boolean = true;


    public location_desired_accuracy = 10;
    public location_stationary_radius = 20;
    public location_high_accuracy = true;
    public screen_height;
    public screen_width;
    public screen_orientation;

    private leaflet_basemap: string;
    private screenOrientationSubject = new Subject<string>();
    private current_trip;

    private okButton;
    private cancelButton;
    private confirmButton;
    private yesButton;
    private noButton;
    
    constructor(private nativeGeocoder:NativeGeocoder,private screenOrientation: ScreenOrientation, private platform: Platform, 
                private alertController: AlertController, private translateService:TranslateService) {}

    public subscribeScreenOrientation(){
            this.screen_height = this.platform.height();
            this.screen_width = this.platform.width();
            this.screen_orientation = this.screenOrientation.type;
            let self = this;
            this.screenOrientation.onChange().subscribe((orientation) => {
                    self.screen_height = self.platform.height();
                    self.screen_width = self.platform.width();
                    self.screen_orientation = self.screenOrientation.type;
                    self.screenOrientationSubject.next(self.screenOrientation.type);
            });
    }
/*
    public setMonthAbbreviations(monthAbbreviationArray){
        this.monthAbbreviations = monthAbbreviationArray; 
    }
    
    public setWeekdaysAbbreviations(weekdaysAbbreviationArray){
        this.weekdaysAbbreviations=weekdaysAbbreviationArray;
    }
*/    

    public setLocale (locale) {
        this.locale = locale; 
    }
    
    public getScreenOrientation() {
        return this.screenOrientationSubject.asObservable();
    }

    public setScreenOrientation() {
        this.screen_orientation = this.screenOrientation.type;
    }
    public getSystemLocale() {
        return navigator.language;
    }
    
    public setCurrentTrip (trip:any){
        this.current_trip = trip;
    }
    
    public getCurrentTrip () {
        return this.current_trip;
    }
    
    public calibratePlaceImages (place:any):any {
        if (place.image_landscape) {
                if (!place.image_portrait) place.image_portrait = place.image_landscape + '?h=2400&w=1400';
                if (!place.image_image_icon) place.image_icon = place.image_landscape + '?h=240&w=140';
                place.image_landscape = place.image_landscape + '?w=2400&h=1400';
        }
        else if (place.image_portrait){
                if (!place.image_landscape) place.image_landscape = place.image_portrait + '?w=2400&h=1400';
                if (!place.image_image_icon) place.image_icon = place.image_portrait + '?h=240&w=140';
                place.image_portrait = place.image_portrait + '?h=2400&w=1400';
        } 
        else {
                let image;
                let category = Math.floor(place.category / PLACE_CATEGORIES.MAIN_CATEGORY_MASK) * PLACE_CATEGORIES.MAIN_CATEGORY_MASK;
                switch (category) {
                            case PLACE_CATEGORIES._EAT_DRINK.id:
                                image = 'assets/images/dinning.jpg';
                                break;
                            case PLACE_CATEGORIES._ACCOMMODATION.id:
                                image = 'assets/images/hotel.jpg';
                                break;
                            default:
                                break;
                }
                place.image_portrait = image + '?h=2400&w=1400';
                place.image_landscape = image + '?w=2400&h=1400';
                if (!place.image_image_icon) place.image_icon = image + '?h=240&w=140';
        }

        return place;
    }
    
    /* Determine the user's current location */
    private getUserCurrentLocation() {

                                let geoCoderOptions: NativeGeocoderOptions = {
                                    useLocale: true,
                                    maxResults: 5
                                };;
                                let geoCoderResult: NativeGeocoderResult;

                                let self = this;
                                
                                let real_ip_resolve = false, ip_resolve=false, ip_reverse_resolve = false;
                                
                                let ip_location, ip_country_code;

                                var ip_address=null,real_ip_address=null;

                                async function real_ip_lookup() {
                                    const controller = new AbortController();
                                    /* get the real ip adddress */
                                    try {
                                        /* get the real ip */
                                        const timeout = setTimeout(() => {
                                                controller.abort();
                                        }, 5000);
                                        
                                        const response = await fetch(`https://httpbin.org/ip`, {
                                            signal: controller.signal
                                        });
                                        clearTimeout(timeout);
                                        const real_ip = await response.json();
                                        real_ip_address = real_ip['origin'];

                                    } catch (e){};
                                    real_ip_resolve = true;
                                }

                                async function ip_lookup() {
                                    const controller = new AbortController();
                                    /* get the ip address */
                                    try{    
                                        const timeout = setTimeout(() => {
                                              controller.abort();
                                         }, 5000);
                                        const response = await fetch('https://api.ipify.org?format=json', {
                                            signal: controller.signal 
                                        });
                                        clearTimeout(timeout);
                                        const data = await response.json();
                                        ip_address = data.ip;

                                     } catch (e){};
                                     ip_resolve = true;
                                }   
                                
                                async function ipReverseLookup(ip){
                                      const controller = new AbortController();
                                      try {    
                                        const timeout = setTimeout(() => {
                                                controller.abort();
                                        }, 5000);

                                        const response = await fetch(`https://ipapi.co/${ip}/json`, {
                                            signal: controller.signal
                                        });
                                        clearTimeout(timeout);
                                        const answer = await response.json();
                                        //var answer = await response.text();
                                        ip_location = {
                                                latitude:answer.latitude,longitude:answer.longitude};
                                        ip_country_code = answer.country_code;
                                      } catch (e) {};
                                     ip_reverse_resolve = true;
                                }
                                
                                async function ipLookup() {
                                    const controller = new AbortController();
                                    real_ip_lookup();
                                    ip_lookup();
                                    
                                    while ((!real_ip_resolve) || (!ip_resolve)) {
                                            await new Promise(resolve => setTimeout(resolve, 50));
                                    }

                                    
                                    if (ip_address == null) {
                                        ip_address = real_ip_address;
                                    }

                                    if (real_ip_address == null){
                                        real_ip_address = ip_address;
                                    }
                                    
                                    if (real_ip_address!=null){
                                        ip_reverse_resolve = false;
                                        ipReverseLookup (real_ip_address);
                                        while (!ip_reverse_resolve) {
                                            await new Promise(resolve => setTimeout(resolve, 50));
                                        }
                                        if (!self._locationBasedOnGeo) {
                                            self.current_location = ip_location;
                                            self.country_code = ip_country_code;
                                        }
                                        self.ip_country_code = ip_country_code;
                                    }

                                    if ((ip_address !=null) && (ip_address != real_ip_address)) {
                                        ip_reverse_resolve = false;
                                        ipReverseLookup (ip_address);
                                        while (!ip_reverse_resolve) {
                                            await new Promise(resolve => setTimeout(resolve, 50));
                                        }
                                        self.ip_country_code = ip_country_code;
                                    }
                                    


                                    if (!self.country_code){
                                        self.country_code = navigator.language.substring(navigator.language.length - 2);
                                    }
                                    if (!self.ip_country_code){
                                        self.ip_country_code = self.country_code;
                                    }
                                    if (!self.current_location){
                                        self.current_location = {latitude:Number(IsoToLatLong[self.country_code].coordinate[0]),longitude:Number(IsoToLatLong[self.country_code].coordinate[1])};
                                    }
                                   }

                                let onSuccess = (position) => {
                                    self.current_location = {
                                        latitude:position.coords.latitude,longitude:position.coords.longitude};
                                    self._locationBasedOnGeo = true;
                                    if(window.cordova){
                                        self.nativeGeocoder.reverseGeocode(self.current_location.latitude, self.current_location.longitude, geoCoderOptions)
                                        .then((result: NativeGeocoderResult[]) => {
                                         //const county = result[0].administrativeArea;
                                         //const city = result[0].locality;
                                         self.country_code = result[0].countryCode;
                                        })
                                        .catch((error: any) => {
                                            console.log(error);
                                        });
                                    }
                                    if (!self.country_code) {
                                        self.country_code = CountryCoder.iso1A2Code([self.current_location.longitude,self.current_location.latitude]);
                                    }
                                    ipLookup();
                                };

                                function onError(error) {
                                    console.log('code: ' + error.code + '\n' + 'message: ' + error.message + '\n');
                                    self._locationBasedOnGeo = false;
                                    ipLookup();
                                }

            navigator.geolocation.getCurrentPosition(onSuccess, onError);
    }

    public async getCurrentLocation() {
        this.getUserCurrentLocation();
    
        while (!this.current_location) {
            await new Promise(resolve => setTimeout(resolve, 50));
        }
    
        while (!this.ip_country_code){
            await new Promise(resolve => setTimeout(resolve, 50));
        }
    }
    

    public setLeafletBaseMap(map: string) {
        this.leaflet_basemap = map;
    }

    public getLeafletBaseMap() {
        return this.leaflet_basemap;
    }

    public distanceFromTo(from:any,to:any){
        let distance = 0;
        if (this.getLeafletBaseMap() == MAP_PROVIDERS.LEAFLET_BASEMAP.BAIDU){
            distance = L.CRS.EPSG3857.distance(from, to)
        }
        else {
            distance = L.latLng(from.lat,from.lng).distanceTo([to.lat,to.lng]);
        }    
        return distance;
    }
    
    public createLeafletMap(mapId: string, centerLocation: any, zoomLevel: number) {

                                let mapOSM = (this.leaflet_basemap == MAP_PROVIDERS.LEAFLET_BASEMAP.BAIDU) ?
                                    new L.Map(mapId, {
                                        crs: L.CRS.Baidu,
                                        maxBounds: L.latLngBounds(
                                            //L.latLng(-85.05112877980659, -180),L.latLng(85.05112877980659, 180)),
                                            L.latLng(-84.5, -180), L.latLng(84.5, 180)),
                                        worldCopyJump: true,
                                        attribution: false,
                                    }) :
                                    new L.Map(mapId, {
                                        maxBounds: [
                                            [-90, -180],
                                            [90, 180]
                                        ],
                                        worldCopyJump: true,
                                        attribution: false,
                                    });


                                mapOSM.setView([centerLocation.latitude, centerLocation.longitude], zoomLevel);
                                mapOSM.removeControl(mapOSM.zoomControl);
                                mapOSM.attributionControl.setPrefix('');

                                if (this.leaflet_basemap == MAP_PROVIDERS.LEAFLET_BASEMAP.GOOGLE) {
                                    L.tileLayer(this.leaflet_basemap + (L.Browser.retina ? '&style=high_dpi&w=512' : ''), {
                                        detectRetina: true,
                                        tileSize: L.Browser.retina ? 512 : 256,
                                        subdomains: [0, 1, 2, 3],
                                        minZoom: MAP_SCOPE.MINZOOM,
                                        edgeBufferTiles: 1,
                                    }).addTo(mapOSM);
                                } else if (this.leaflet_basemap == MAP_PROVIDERS.LEAFLET_BASEMAP.OSM) {
                                    L.tileLayer(this.leaflet_basemap, {
                                        subdomains: ['a', 'b', 'c'],
                                        minZoom: MAP_SCOPE.MINZOOM,
                                    }).addTo(mapOSM);
                                } else if (this.leaflet_basemap == MAP_PROVIDERS.LEAFLET_BASEMAP.GAODE) {
                                    L.tileLayer(this.leaflet_basemap + (L.Browser.retina ? '&size=1024*1024&scale=2' : '&size=1&scale=1'), {
                                        subdomains: ['1', '2', '3', '4'],
                                        minZoom: MAP_SCOPE.MINZOOM + 1,
                                    }).addTo(mapOSM);
                                } else if (this.leaflet_basemap == MAP_PROVIDERS.LEAFLET_BASEMAP.BAIDU) {
                                    L.tileLayer.baiduLayer(this.leaflet_basemap + (L.Browser.retina ? '&scaler=2' : '&scaler=1'), {
                                        tms: true,
                                        subdomains: '0123',
                                        minZoom: MAP_SCOPE.MINZOOM + 1,
                                        edgeBufferTiles: 1,
                                    }).addTo(mapOSM);
                                }
                                mapOSM.eachLayer((layer) => {
                                    if (!(layer instanceof L.TileLayer)) {
                                        mapOSM.removeLayer(layer);
                                    }
                                });
                                return mapOSM;
                            }

    
    public async presentAlert(header:string,message:string,buttonNames){
        var buttons = [];
        buttonNames.forEach((name)=>{
                buttons.push(this[`${name}Button`]);   
        });

        const alert = await this.alertController.create({
                header: header,
                message: message,
                buttons:buttons
        });
        
        await alert.present();
    }
    
    public setupDialogBoxMessages(){
        this.okButton = {
            text:this.translateService.instant('okButton'),
        }
        this.cancelButton = {
            text:this.translateService.instant('cancelButton'),
            role:'cancel',
        }
        this.confirmButton = this.translateService.instant('confirmButton');
        this.yesButton = this.translateService.instant('yesButton');
        this.noButton = this.translateService.instant('nolButton');
    } 
}
    


                        /*
                            Service class should be exported as ExportedClass
                        */
    export {
                            NeurService as ExportedClass
    };